import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetDetailPreviousYearsAmountsDTO  {
    _originalTypeClassName = "zERP.BO.BudgetDetailPreviousYearsAmountsDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetDetailPreviousYearsAmountsDTO.translate = translateService;
}
this.Id = null;
this.AmountLastYear = null;
this.Amount2YearBefore = null;
this.BudgetDetailPreviousYearsAmountsDTOKey = null;
this._key = this.BudgetDetailPreviousYearsAmountsDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
AmountLastYear:any;
Amount2YearBefore:any;
private _BudgetDetailPreviousYearsAmountsDTOKey:any;
get BudgetDetailPreviousYearsAmountsDTOKey(): any {
    return this._BudgetDetailPreviousYearsAmountsDTOKey;
  }
set BudgetDetailPreviousYearsAmountsDTOKey(value: any) {
    this._BudgetDetailPreviousYearsAmountsDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BudgetDetailPreviousYearsAmountsDTOKey == null || $this.BudgetDetailPreviousYearsAmountsDTOKey == 0;
            }


}